import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment'
import { FidelidadeService } from './fidelidade.service';

import { Imagem } from '../_models/imagem';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UploadFilesService {

  constructor(private http: HttpClient,
    private fidelidadeService: FidelidadeService) { }

  upload(file: File): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    formData.append('file', file);

    const req = this.fidelidadeService.uploadFoto(formData);

    return this.http.request(req);
  }

  getPhotoProfile(): Observable<Imagem> {
    return this.fidelidadeService.getFoto().pipe(map(res => { return res }));
  }
}